import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TransactionService } from 'app/services/transaction.service';
import { pdfReporteActividadDetalladaTemplate } from 'app/templates/pdf-export/pdf-activity-detailed-report';
import { pdfReporteActividadTemplate } from 'app/templates/pdf-export/pdf-activity-report';
import { pdfReporteIngresosTemplate } from 'app/templates/pdf-export/pdf-revenue';
import { pdfReporteEstadoActualTemplate } from 'app/templates/pdf-export/pdf-status';
import { PDF } from 'app/utils/pdf';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  reportForm: FormGroup;
  reportType = 'activity';
  loading = false;
  result: any = null;
  error = '';

  constructor(
    private transactionService: TransactionService,
    private fb: FormBuilder,
    private pdf: PDF,
    private spinner: NgxSpinnerService
  ) {
    this.reportForm = this.fb.group({
      date: [''],
      startDate: [''],
      endDate: [''],
      transactionType: [''],
      containerTypeId: [''],
      includeMovements: [true, '']
    });
  }

  ngOnInit(): void {}

  onReportTypeChange(type: string) {
    this.reportType = type;
    this.result = null;
    this.error = '';
  }

  submit() {
    this.loading = true;
    this.spinner.show();
    this.result = null;
    this.error = '';
    const params = this.buildParams();
    let obs;
    let nombreArchivo = '';
    switch (this.reportType) {
      case 'activity':
        obs = this.transactionService.getActivityReport(params);
        nombreArchivo = `Reporte_Actividad_${params.date || 'General'}_${new Date().getTime()}`;
        break;
      case 'revenue':
        obs = this.transactionService.getRevenueReport(params);
        nombreArchivo = `Reporte_Ingresos_${params.date || 'General'}_${new Date().getTime()}`;
        break;
      case 'status':
        obs = this.transactionService.getStatusReport(params);
        nombreArchivo = `Reporte_Estado_${params.date || 'General'}_${new Date().getTime()}`;
        break;
      default:
        this.loading = false;
        this.error = 'Tipo de reporte no soportado';
        return;
    }
    obs.subscribe({
      next: (res) => {
        this.result = res;
        this.loading = false;
        this.genPdf(res, nombreArchivo, this.reportType);
      },
      error: (err) => {
        this.error = 'Error al obtener el reporte';
        this.loading = false;
      }
    });
  }


  async genPdf(report: any, nombreArchivo: string, type: string = 'activity') {
    this.spinner.show();
    let docDefinition;
    if (type === 'revenue') {      
      docDefinition = await pdfReporteIngresosTemplate(report);
    } else if (type === 'activity') {
      docDefinition = await pdfReporteActividadTemplate(report);
    } else if (type === 'status') {
      docDefinition = await pdfReporteEstadoActualTemplate(report);
    } else {
      this.spinner.hide();
      return;
    }

    this.pdf.exportAsPDFFile(docDefinition, nombreArchivo);
    this.spinner.hide();
  }

  buildParams() {
    const form = this.reportForm.value;
    const params: any = {};
    // El rango manda: enviar `date` junto con el rango hacía que el
    // backend priorizara `date` y descartara el rango en silencio.
    if (form.startDate && form.endDate) {
      params.startDate = form.startDate;
      params.endDate = form.endDate;
    } else if (form.date) {
      params.date = form.date;
    }
    if (form.transactionType) params.transactionType = form.transactionType;
    if (form.containerTypeId) params.containerTypeId = form.containerTypeId;
    params.includeMovements = true;
    return params;
  }
}
